// Loader component that displays the Loading message when movie list is fetching
export default function Loader() {
  return <p className="loader">Loading...</p>;
}